import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import EvaluationsSettingsForm from './EvaluationsSettingsForm';
import i18n from 'i18n';

interface EvaluationsSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeEvaluationId: number;
}

const EvaluationsSettingsModal: React.FC<EvaluationsSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeEvaluationId,
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_evaluation_settings.text')}
        entityId={activeEvaluationId}
        entityIdPropName="evaluationId"
        FormComponent={EvaluationsSettingsForm}
    />
));

EvaluationsSettingsModal.displayName = 'EvaluationsSettingsModal';

export default EvaluationsSettingsModal; 